import axios from 'axios'

export default {
  name: 'updateFeeds',

  methods: {
    updateProjectFeeds () {
      this.$bvToast.toast(this.$t('feeds.feeds_updating_description'), {
        autoHideDelay: 3000,
        solid: true,
        title: this.$t('feeds.feeds_updating'),
        variant: 'info'
      })

      axios.get(process.env.VUE_APP_API_ENDPOINT + '/feed/update/' + this.$route.params.id)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            window.dataLayer.push({ event: 'runFeedsUpdate' })
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$bvToast.toast(this.$t('feeds.feeds_updating_error_description'), {
              autoHideDelay: 3000,
              solid: true,
              title: this.$t('feeds.feeds_updating_error'),
              variant: 'danger'
            })
          }
        })
    }
  }
}
